import { UserMessageColor } from 'src/app/core/user-message/user-message-color';
import { UserMessageIcon } from 'src/app/core/user-message/user-message-icon';
import { WritablePart } from 'src/app/core/utils/type-helper';

export class UserMessage {
  readonly timestamp: number;
  readonly messageParts: string[];

  message: string | string[];
  icon: UserMessageIcon;
  durationMs: number;
  position: 'top' | 'middle' | 'bottom';
  color: UserMessageColor;
  showCloseButton: boolean;

  constructor(init?: Partial<WritablePart<UserMessage>>) {
    Object.assign(this, init);
    this.timestamp = Date.now();

    if (Array.isArray(this.message)) {
      this.messageParts = this.message;
    } else {
      this.messageParts = [this.message];
    }
  }
}
